import { render, staticRenderFns } from "./Earth.vue?vue&type=template&id=31449261&scoped=true&"
import script from "./Earth.vue?vue&type=script&lang=js&"
export * from "./Earth.vue?vue&type=script&lang=js&"
import style0 from "./Earth.vue?vue&type=style&index=0&id=31449261&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31449261",
  null
  
)

export default component.exports